import React from 'react';
import { ConfigProvider } from 'antd';

export default function ConfigurationProvider({ children }) {
  return (
    <ConfigProvider 
      locale={{
        Table: {
          triggerAsc: 'Click to sort in ascending',
          triggerDesc: 'Click to sort in descending',
          cancelSort: 'Click to cancel sorting'
        }
      }}
      csp={{ nonce: 'nonce-e73f1ece5087b8a5ae33998952202202'}}>
      {children}
    </ConfigProvider>
  );
}
